import React from 'react';
import classNames from 'classnames';
import { styled } from '@mui/styles';

const Text = styled(({ children, className, ...props }) => (
    <span className={classNames(className, props.mode)} onClick={props.onClick}>
        {children}
    </span>
))(({ theme }: any) => ({
    color: theme.palette.primary.light,
    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.primary.main,
        borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    '&.red': {
        color: theme.palette.colors.red,
        '&:hover': {
            color: theme.palette.colors.redPale,
            borderBottom: `1px solid ${theme.palette.colors.redPale}`,
        },
    },
    '&.blue': {
        color: theme.palette.colors.blue,
        '&:hover': {
            color: theme.palette.colors.bluePale,
            borderBottom: `1px solid ${theme.palette.colors.bluePale}`,
        },
    },
    '&.green': {
        color: theme.palette.colors.green,
        '&:hover': {
            color: theme.palette.colors.greenPale,
            borderBottom: `1px solid ${theme.palette.colors.greenPale}`,
        },
    },
    '&.black': {
        color: theme.palette.colors.blackLighter,
        '&:hover': {
            color: theme.palette.colors.black,
            borderBottom: `1px solid ${theme.palette.colors.black}`,
        },
    },
    '&.white': {
        color: theme.palette.graphics.stroke,
        '&:hover': {
            color: theme.palette.colors.white,
            borderBottom: `1px solid ${theme.palette.colors.white}`,
        },
    },
}));

export const TextColor = {
    red: 'red',
    blue: 'blue',
    green: 'green',
    black: 'black',
    white: 'white',
};
/* eslint-disable-next-line */
export interface ActionTextProps {
    text: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    class?: string;
}

export function ActionText(props: ActionTextProps) {
    return (
        <Text mode={props.class} onClick={props.onClick}>
            {props.text}
        </Text>
    );
}

export default ActionText;
